/**
 * Convenience fee promo — global env controls (CRA build-time).
 *
 * REACT_APP_PROMO_ENABLED
 *   - false: master kill switch — no promo surfaces anywhere (popup, banners, etc.)
 *   - true:  promos follow PROMO_CONFIG + lifecycle rules (default)
 *
 * REACT_APP_PROMO_QA_MODE
 *   - true:  QA/testing — previewMode on, all surface cooldowns set to 0
 *            (bypasses cooldown, campaign status, and campaign dates)
 *   - false: production behaviour (default)
 *
 * Restart the dev server after changing .env values.
 */

function parseEnvFlag(value) {
  return value === 'true';
}

/** When false, canShowPromotion() blocks every surface. */
export const promoEnvFlags = {
  enabled: process.env.REACT_APP_PROMO_ENABLED !== 'false',
  qaMode: parseEnvFlag(process.env.REACT_APP_PROMO_QA_MODE),
};

export default promoEnvFlags;
